import { useState } from "react";

import Typography from "../Typography/Typography";
import styles from "./TextInput.module.scss";

import { ReactComponent as EyeIcon } from "../../assets/eye.svg";
import { ReactComponent as NotEyeIcon } from "../../assets/notEye.svg";
import { palette } from "../../theme/theme";

const TextInput = (props) => {
	const {
		type = "text",
		name = "",
		label = "",
		placeholder = "",
		value,
		defaultValue = "",
		onChange = () => {},
		onBlur = () => {},
		onFocus = () => {},
		className = "",
		inputClassName = "",
		disabled = false,
		error = false,
		errorText = "",
		helperText = "",
		hideFeedback = false,
		setError = () => {},
		pattern = null,
		formatter = null,
		leftElement = null,
		rightElement = null,
		enablePasswordToggle = false,
		style = {},
		...rest
	} = props;

	const isPasswordField = type === "password";
	const [isPasswordVisible, setIsPasswordVisible] = useState(false);
	const [internalValue, setInternalValue] = useState(defaultValue);

	const isControlled = value !== undefined;
	const currentValue = isControlled ? value : internalValue;

	const resolvedInputType =
		isPasswordField && enablePasswordToggle
			? isPasswordVisible
				? "text"
				: "password"
			: type;

	const handleFormattedValue = (rawValue) => {
		let nextValue = rawValue;

		if (typeof formatter === "function") {
			nextValue = formatter(rawValue);
		} else if (pattern) {
			nextValue = rawValue.replace(pattern, "");
		}

		if (!isControlled) {
			setInternalValue(nextValue);
		}

		onChange(nextValue);
	};

	const passwordToggleElement =
		isPasswordField && enablePasswordToggle ? (
			<button
				type="button"
				className={styles.iconButton}
				onClick={() => setIsPasswordVisible((prev) => !prev)}
				tabIndex={-1}
				aria-label={
					isPasswordVisible
						? "Ocultar contraseña"
						: "Mostrar contraseña"
				}
			>
				{isPasswordVisible ? (
					<NotEyeIcon className={styles.passwordToggleIcon} />
				) : (
					<EyeIcon className={styles.passwordToggleIcon} />
				)}
			</button>
		) : null;

	const resolvedRightElement = passwordToggleElement || rightElement;

	return (
		<div
			className={`${styles.textInputContainer} ${className}`}
			style={style}
		>
			{label && (
				<Typography
					style={{ fontSize: "12px", color: palette.grey[600] }}
					bold
					variant="span"
					className={styles.label}
					color=""
				>
					{label}
				</Typography>
			)}

			<div
				className={`
					${styles.inputWrapper}
					${error ? styles.inputWrapperError : ""}
					${disabled ? styles.inputWrapperDisabled : ""}
					${leftElement ? styles.hasLeftElement : ""}
					${resolvedRightElement ? styles.hasRightElement : ""}
				`}
			>
				{leftElement && (
					<div className={styles.leftElement}>{leftElement}</div>
				)}

				<input
					{...rest}
					name={name}
					type={resolvedInputType}
					value={currentValue}
					placeholder={placeholder}
					disabled={disabled}
					className={`${styles.textInput} ${inputClassName}`}
					onChange={(e) => handleFormattedValue(e.target.value)}
					onFocus={(e) => {
						setError(false);
						onFocus(e);
					}}
					onBlur={(e) => {
						onBlur(e);
					}}
				/>

				{resolvedRightElement && (
					<div className={styles.rightElement}>
						{resolvedRightElement}
					</div>
				)}
			</div>

			{!hideFeedback ? (
				<div className={styles.feedbackSlot}>
					{error && errorText ? (
						<Typography className={styles.feedbackTextError}>
							{errorText}
						</Typography>
					) : helperText ? (
						<Typography className={styles.feedbackText}>
							{helperText}
						</Typography>
					) : null}
				</div>
			) : null}
		</div>
	);
};

export default TextInput;
